import axios from "axios";
import { ENDPOINTS } from "./_config";

// Three call normally needed to upload files: upload
// export async function uploadKnowledgeBase(trialID, files) {
//   try {
//     const uploadResults = [];

//     for (const file of files) {
//       const formData = new FormData();
//       formData.append("Files", file);

//       const response = await axios.put(
//         `${ENDPOINTS.WORKFLOW.UPLOAD_KNOWLEDGE_BASE}?trialID=${trialID}`,
//         formData,
//         {
//           headers: {
//             accept: "text/plain",
//           },
//           responseType: "text", // since the response is text/plain
//         }
//       );

//       console.log(`Uploaded: ${file.name}`, response.data);
//       uploadResults.push({
//         fileName: file.name,
//         status: "success",
//         response: response.data,
//       });
//     }

//     return uploadResults;
//   } catch (error) {
//     console.error("Error uploading files:", error);
//     throw error;
//   }
// }

// Three call with Promise.all
export async function uploadKnowledgeBase(trialID, files) {
  try {
    // Create an array of promises for all file uploads
    const uploadPromises = files.map((file) => {
      const formData = new FormData();
      formData.append("Files", file);

      return axios
        .put(
          `${ENDPOINTS.WORKFLOW.UPLOAD_KNOWLEDGE_BASE}?trialID=${trialID}`,
          formData,
          {
            headers: {
              accept: "text/plain",
            },
            responseType: "text", // since the response is text/plain
          }
        )
        .then((response) => ({
          fileName: file.name,
          status: "success",
          response: response.data,
        }))
        .catch((error) => ({
          fileName: file.name,
          status: "error",
          error: error.message,
        }));
    });
console.log('uploadPromises', uploadPromises)
    // Wait for all uploads to complete
    const uploadResults = await Promise.all(uploadPromises);

    // Log results for debugging
    uploadResults.forEach((result) => {
      if (result.status === "success") {
        console.log(`Uploaded: ${result.fileName}`, result.response);
      } else {
        console.error(`Failed: ${result.fileName}`, result.error);
      }
    });

    return uploadResults;
  } catch (error) {
    console.error("Error uploading files:", error);
    throw error;
  }
}


export const deleteKnowledgeBaseFile = async (trialID, fileID) => {
  try {
    const response = await axios.delete(
      ENDPOINTS.WORKFLOW.DELETE_KNOWLEDGE_BASE_FILE,
      {
        params: {
          trialID,
          fileID,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
};
